module.exports = __webpack_public_path__ + "media/images/pic/gallery/2019/warsztaty-obento-8742b060c7d2e0f37ca98943e08af0f9.jpg";